import { Reddit, RedditThumbnail } from './type'

const INVALID_THUMBNAIL: RedditThumbnail[] = ['self', 'default', 'image']

export const parseReddit = (reddit: Reddit) => ({
  href: INVALID_THUMBNAIL.includes(reddit.thumbnail?.url || '') ? '' : reddit.thumbnail?.url,
  extend: {
    width: reddit.thumbnail?.width,
    height: reddit.thumbnail?.height,
  },
})
